import { SvgIcon } from "@mui/material";

// inline style on paths beats SvgIcon's `fill: currentColor` CSS rule
const WhatsAppIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      style={{ fill: "#25D366" }}
      d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.38 1.26 4.8L2.05 22l5.44-1.43c1.38.75 2.95 1.19 4.55 1.19 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2z"
    />
    <path
      style={{ fill: "#fff" }}
      d="M17.12 14.56c-.26-.13-1.55-.77-1.79-.85-.24-.09-.42-.13-.6.13-.17.26-.68.85-.83 1.02-.15.17-.31.19-.57.06-.26-.13-1.1-.41-2.1-1.3-.77-.69-1.3-1.54-1.45-1.8-.15-.26-.02-.4.11-.53.12-.12.26-.31.39-.46.13-.15.17-.26.26-.43.09-.17.04-.32-.02-.45-.06-.13-.6-1.45-.82-1.99-.22-.52-.44-.45-.6-.46-.15 0-.33-.01-.51-.01-.17 0-.45.06-.69.32-.24.26-.9.88-.9 2.14 0 1.26.92 2.48 1.05 2.65.13.17 1.81 2.77 4.38 3.88.61.26 1.09.42 1.46.54.61.19 1.17.16 1.61.1.49-.07 1.55-.63 1.77-1.24.22-.61.22-1.13.15-1.24-.06-.11-.24-.17-.5-.3z"
    />
  </SvgIcon>
);

export default WhatsAppIcon;
